import { TFeature } from "@/api/v1_0";

export namespace Features {
  export namespace Account {
    export const Qr: TFeature = TFeature.Value7A3915E4Ee0647228Df237999Bddb225;
    export const Management: TFeature =
      TFeature.Value68E71955A0D34F628F1595Dd3203A112;
  }

  export namespace Analytics {
    export const View: TFeature = TFeature.Aaafc749879240E29EbcE047Aa2Cfd3D;
  }

  export namespace Pro {
    export const Purchase: TFeature =
      TFeature.Value6219A1C9D1894B5C92C943Bfc7D3A44C;
  }
}
